import { FC, useEffect, useState } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { useGetArticleData } from 'hooks/useGetArticleData';
import { useGetProgressData } from 'hooks/useGetProgressData';
import { usePageTitle } from 'hooks/usePageTitle';
import { useRemoveRubyTags } from 'hooks/useRemoveRubyTags';

import { Button } from 'components/parts/Button';
import { ButtonLink } from 'components/parts/ButtonLink';
import BgTitle from 'images/area/answer/bg_title.svg';

import styles from './AnswerResult.module.scss';
export const AnswerResult: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const article = useGetArticleData(id || '');
  const { data: progressData } = useGetProgressData();
  const [nextUrl, setNextUrl] = useState('/home');
  usePageTitle(useRemoveRubyTags(article?.name));

  function getClearCardFileName() {
    return `${String(id).padStart(3, '0')}_clear-card.webp`;
  }

  useEffect(() => {
    if (!id) return;
    if (progressData?.completedAreaList.length === 19) {
      setNextUrl('/ending');
    } else {
      setNextUrl('/home');
    }
  }, [id, progressData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.head}>
          <h1 className={styles.title}>
            <img src={BgTitle} alt="クリアカードGET" className={styles.titleImage} />
          </h1>
        </div>
        <div className={styles.body}>
          <div className={styles.imageWrap}>
            <img
              src={require(`images/character/chara-kirakira.webp`)}
              alt=""
              className={styles.chara}
            />
            <img
              src={require(`components/pages/Area/images/${getClearCardFileName()}`)}
              alt=""
              className={styles.image}
            />
            <div className={styles.sparcles}>
              <svg
                className={styles.sparcle1}
                id="sparcle1"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
                  fill="url(#paint0_radial_633_6738)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_633_6738"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 16) rotate(90) scale(12 10)"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFE588" />
                  </radialGradient>
                </defs>
              </svg>
              <svg
                className={styles.sparcle2}
                id="sparcle2"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
                  fill="url(#paint0_radial_633_6738)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_633_6738"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 16) rotate(90) scale(12 10)"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFE588" />
                  </radialGradient>
                </defs>
              </svg>
              <svg
                className={styles.sparcle4}
                id="sparcle4"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
                  fill="url(#paint0_radial_633_6738)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_633_6738"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 16) rotate(90) scale(12 10)"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFE588" />
                  </radialGradient>
                </defs>
              </svg>
              <svg
                className={styles.sparcle3}
                id="sparcle3"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
                  fill="url(#paint0_radial_633_6738)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_633_6738"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 16) rotate(90) scale(12 10)"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFE588" />
                  </radialGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
        <div className={styles.action}>
          <div className={styles.actionBody}>
            <Button
              text={nextUrl === '/ending' ? 'エンディングへ' : 'ホームに戻る'}
              styleType="primary"
              handleClick={() => navigate(nextUrl)}
            />
          </div>
          {article?.relatedUrl && (
            <div className={styles.actionFoot}>
              <ButtonLink
                text="ハンターポイントをGETする"
                href={article.relatedUrl}
                styleType="secondaryWide"
                target="_blank"
              />
              <div className={styles.actionFootText}>※ハンターズヴィレッジ会員用</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
